<template>
  <b-form-group
    label="Açıklama"
    label-for="description"
  >
    <b-form-textarea
      id="description"
      v-model="dataItem.description"
      placeholder="Açıklama"
      rows="3"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
  BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'DescriptionText',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
}
</script>
